<script type="text/javascript">
  // 定义一些公共的属性和方法

  //网络请求地址
  //const httpUrl = 'http://182.131.17.138:86/';
  //const httpUrl = 'http://hh.swuee.cn:86/';
  const httpUrl = 'http://api.swuee.cn:86/';//最新接口地址
  //混改服务
  const serviceUrl = httpUrl + 'article';
  //项目列表
  const projectUrl = httpUrl + 'project/?';
  const projectDetailUrl = httpUrl + 'protrans/?';
  //热点标签
  const tagListUrl = httpUrl + 'setting/?';


  //公用token
  const token = 'e499999383354cdd943004eb71448dbd';
  //公用orgid
  const orgid = 'ins_035';//打包之前记得改这里

  /*
  西交所 ins_045
  西藏所 ins_099
  河北 ins_062
  北京产权交易所	ins_001
  上海联合产权交易所	ins_002
  天津产权交易中心	ins_003
  内蒙古产权交易中心	ins_004
  北部湾产权交易所	ins_005
  青海产权交易所	ins_006
  南平市产权交易中心有限公司	ins_007
  甘肃省产权交易所	ins_008
  南通众和产权交易所	ins_009
  江苏省产权交易所	ins_010
  宁夏科技资源与产权交易所	ins_011
  黑龙江联合产权交易所	ins_012
  湖南省联合产权交易所有限公司	ins_013
  新疆产权交易所	ins_014
  云南产权交易所	ins_015
  江西省产权交易所	ins_016
  海南产权交易所	ins_017
  山西省产权交易市场	ins_018
  常州产权交易所	ins_019
  常州拍卖有限公司	ins_021
  江苏省常产拍卖有限公司	ins_023
  安徽长江产权交易所	ins_026
  西部产权交易所	ins_028
  深圳联合产权交易所	ins_031
  厦门产权交易中心	ins_032
  山东产权交易中心	ins_033
  浙江产权交易所	ins_034
  广州产权交易所	ins_035
  河南中原产权交易有限公司	ins_037
  大连产权交易所	ins_038
  安徽省产权交易中心	ins_039
  青岛产权交易所	ins_040
  宁波产权交易中心	ins_041
  重庆联合产权交易所	ins_043
  吉林长春产权交易中心	ins_044
  西南联合产权交易所	ins_045
  沈阳联合产权交易所	ins_046
  新疆伊犁哈萨克自治州联合产权交易有限责任公司	ins_047
  河南省产权交易中心	ins_049
  贵州阳光产权交易所	ins_050
  福建省产权交易中心	ins_052
  山西省产权交易中心	ins_053
  绍兴市公共资源交易中心	ins_054
  广东联合产权交易中心	ins_056
  安徽长江农林产权交易所	ins_059
  长治市产权交易市场	ins_060
  广西联合产权交易所	ins_061
  河北产权市场	ins_062
  泉州市产权交易中心	ins_063
  黑龙江省龙法拍卖有限责任公司	ins_065
  武汉光谷  ins_066
  珠海      ins_067
  */

  //公用方法
  /**
   *  日期格式化，-拼接
   * */
  function dateFormat(time) {
    var date = "";
    if (time!=undefined && time.length == 10) {
      date = new Date(parseInt(time) * 1000);
    } else if (time!=undefined && time.length == 13) {
      date = new Date(parseInt(time));
    }

    var year = date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    // 拼接
    return year + "-" + month + "-" + day;
  }

  /**
   * 日期格式化 年月日
   * */
  function dateFormatYmd(time) {
    var date=new Date(parseInt(time)*1000);
    var year=date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
    var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
    // 拼接
    return year+"年"+month+"月"+day+"日";
  }

  /**
   * 日期格式化 年月日时分秒
   * */
  function dateFormatYmdhms(time) {
    var date=new Date(parseInt(time)*1000);
    var year=date.getFullYear();
    /* 在日期格式中，月份是从0开始的，因此要加0
     * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
     * */
    var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
    var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
    var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
    var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
    var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
    // 拼接
    return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
  }

  /**
   * 金额格式化
   * */
  function priceFormat(price) {
    if(!price) return '0.00';
    /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
    var intPart =  Number(price)|0; //获取整数部分
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

    var floatPart = ".00"; //预定义小数部分
    var value2Array = price.split(".");

    //=2表示数据有小数位
    if(value2Array!=undefined && value2Array.length == 2) {
      floatPart = value2Array[1].toString(); //拿到小数部分

      if(floatPart!=undefined && floatPart.length == 1) { //补0,实际上用不着
        return intPartFormat + "." + floatPart + '0';
      } else {
        return intPartFormat + "." + floatPart;
      }
    } else {
      return intPartFormat + floatPart;
    }
  }

  /**
   * 文本长度18
   */
  function maxLength18(val) {
    if (val.length > 19) {
      return val.substring(0, 18) + "..."
    }
    return val;
  }

  /**
   * 文本长度50
   */
  function maxLength50(val) {
    if (val.length > 51) {
      return val.substring(0, 50) + "..."
    }
    return val;
  }

  /**
   * 百分比处理
   */
  function filPercent(val) {
    var reg=/^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/
    if(reg.test(val)){
      val = val +'%';
    }
    return val;
  }

  // 暴露出这些属性和方法
  export default {
    token,
    orgid,
    serviceUrl,
    projectUrl,
    projectDetailUrl,
    tagListUrl,
    dateFormat,
    dateFormatYmd,
    dateFormatYmdhms,
    priceFormat,
    maxLength18,
    maxLength50,
    filPercent
  }
</script>



// WEBPACK FOOTER //
// src/components/public/Common.vue